
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot,ResolveFn,Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { of, switchMap } from 'rxjs';
import { Person2EntityActionTypes } from '../State/actions/person2entity.action';
import { getPerson2EntitiesFetched } from '../State/selectors/person2entity.selectors';
import { distinctUntilChanged, take, tap } from 'rxjs/operators';
import { Person2EntityResolver } from './person2Entity.resolver';

export const Person2EntityByPersonIdResolver: ResolveFn<number> = (route: ActivatedRouteSnapshot) => {
    const store = inject(Store);
    const person2EntityResolver = inject(Person2EntityResolver);
    const id = route.paramMap.get('personId')!;

    if (!id) return of(null);
    return store.select(getPerson2EntitiesFetched).pipe(
        distinctUntilChanged(),
        switchMap((fetched) => {
            if (!fetched) {
                store.dispatch(Person2EntityActionTypes.Load({ Payload: { personId: +id } }));
            } else {
                person2EntityResolver.resolve();
            }
            return of(+id);
        }),
        take(1),
    );
};
